var _rect, _path, _path2, _rect2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConvertToSubtitlesNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 537,
    height: 216,
    viewBox: "0 0 537 216",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.555542,
    width: 240,
    height: 216,
    fill: "#47545E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M189.621 31.9091H41.0176M176.42 38.8273H40.9796M189.621 46.2066L40.7993 46.2066M40.7718 67.4222H157.771M181.282 83.3123H40.9936M167.034 90.6917H40.9526M173.994 122.482H40.8088M117.004 129.861H40.6446M184.327 53.1248H40.9901M189.621 60.0429H40.9521M173.957 98.4789H40.7718M116.967 105.858H40.6076M180.65 145.165H40.3623M166.403 152.545H40.3212M173.325 160.332H40.1404M116.336 167.711H39.9762",
    stroke: "white",
    strokeWidth: 2.592,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.78,
    d: "M31.7556 75.717H209.356M31.7556 114.09H209.356M31.7556 137.59H209.356",
    stroke: "white",
    strokeWidth: 0.54,
    strokeLinecap: "square",
    strokeDasharray: "2.16 2.16"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 296.556,
    width: 240,
    height: 216,
    fill: "#47545E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M485.621 31.2H337.018M472.42 37.9644H336.979M485.621 53.1797H336.799M336.772 80.3239H453.77M477.282 94.2609H336.993M463.034 101.476H336.952M469.994 135.76H336.809M413.004 142.975H336.644M480.327 59.9441H336.99M485.621 73.1085H336.952M469.957 114.69H336.772M412.967 121.906H336.607M476.65 156.34H336.362M462.403 163.555H336.321M469.325 177.569H336.14M412.335 184.784H335.976",
    stroke: "white",
    strokeWidth: 2.592,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.78,
    d: "M327.755 86.8343H505.355M327.755 108.354H505.355M327.755 128.932H505.355M327.755 45.2343H505.355M327.755 66.8343H505.355M327.755 149.732H505.355M327.755 170.532H505.355",
    stroke: "white",
    strokeWidth: 0.54,
    strokeLinecap: "square",
    strokeDasharray: "2.16 2.16"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M284.016 111.461C284.602 110.875 284.602 109.925 284.016 109.339L274.47 99.7934C273.885 99.2076 272.935 99.2076 272.349 99.7934C271.763 100.379 271.763 101.329 272.349 101.915L280.834 110.4L272.349 118.885C271.763 119.471 271.763 120.421 272.349 121.007C272.935 121.592 273.885 121.592 274.47 121.007L284.016 111.461ZM254.156 111.9H282.956V108.9H254.156V111.9Z",
    fill: "#47545E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConvertToSubtitlesNote);
export default __webpack_public_path__ + "static/media/convert-to-subtitles-note.3bedcc1b8e5188bcba3749f504551154.svg";
export { ForwardRef as ReactComponent };